import api from '@/api/_cca-mobile';
import DiagnosticModal from '@/views/consultations/en-cours/hypothese-diagnostic/manage-diagnosis';
import $ from 'jquery';

export default {
    name: 'diagnostics',
    components: {
        DiagnosticModal
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object
    },

    data() {
        return {
            diagnostic_loading: true,
            load_error: false,
            diagnostic_is_empty: false,

            group_id: 0,
            data_info: {
                is_diagnostic: 1,
                libelle: 'Diagnostics',
                data_type: 'diagnostic'
            },
            modal_toggler: 0,
            data_to_be_deleted: {},
            info_user: {},

            selectedDiagnostic: undefined,
            isSharingDiagnostic: false,
        }
    },

    watch: {
        evolution_toggler() {
            this.getConsultationDiagnostics()
            this.userInfoSetter()
        }
    },

    computed: {
        consultation_diagnostics() {
            return this.$store.getters["consultation_diagnostics"]
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        },
    },

    mounted() {
        this.userInfoSetter()
        this.getConsultationDiagnostics()
    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        getConsultationDiagnostics() {
            this.diagnostic_loading = true
            this.load_error = false
            let data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                is_diagnostic: 1,
                data_type: 'diagnostic',
                enCours: true
            }
            return this.$store.dispatch("getConsultationDiagnostics", data).then(() => {
                if (this.consultation_diagnostics.length > 0) {
                    this.diagnostic_is_empty = false
                } else {
                    this.diagnostic_is_empty = true
                }
            }).catch(() => {
                this.load_error = true
            }).finally(() => {
                this.diagnostic_loading = false
            })
        },

        addToDiagnostic(group_id) {
            this.group_id = group_id
            this.modal_toggler = (this.modal_toggler === 0) ? 1 : 0

            this.data_info = {
                is_diagnostic: 1,
                libelle: 'Diagnostics',
                data_type: 'diagnostic'
            }
            $('.diagnosis-mdl-' + this.evolution_id + this.data_info.data_type).modal('show')
        },

        removeDiagnosis(data, group_id) {
            this.data_to_be_deleted = {
                id: data.id,
                libelle: data.libelle,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: group_id,
                data_type: 'diagnostic',
                is_diagnostic: 1
            }
            $('.del-diagnosis-' + this.evolution_id + this.data_info.data_type).modal('show')
        },

        removeGroupDiagnosis(group_diagnosis) {
            this.data_to_be_deleted = {
                libelle: group_diagnosis.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: group_diagnosis.diagnosis_group_id,
                data_type: 'diagnostic'
            }
            $('.del-grp-diagnosis-' + this.evolution_id + this.data_info.data_type).modal('show')
        },

        async handleConfirmSharing() {
            this.isSharingDiagnostic = true;

            try {
                const response = await api.shareDiagnostic(this.selectedDiagnostic.reference);

                if (response && response.status === 200) {
                    this.successToast("Diagnostic(s) partagé(s) avec succès")
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 400 || error.response.status === 422) {
                        this.errorToast("Erreur de requête", 'error')
                    } else if (error.response.status === 500) {
                        this.errorToast("Une erreur s'est produitre, veuillez réessayer plustard", 'error')
                    }
                }
            } finally {
                this.isSharingDiagnostic = false;

                $('.modal').modal('hide');
            }
        }
    },
}
